import React from 'react'
import { GlobalDataContext, useTransactionStore } from '../../common'

export const useTransactionsUiStore = () => {
  const context = React.useContext(GlobalDataContext)

  if (!context) {
    throw new Error('useTransactionsUiStore() must be used within the GlobalDataContext')
  }

  return useTransactionStore().uiStore
}
